<template>
    <v-container fluid class="invoice_container container-full-bg-white">

        <!-- Componentes emergentes -->

        <v-snackbar v-if="screen_data" v-model="screen_data.snackbar.isVisible" :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout">
            {{ screen_data.snackbar.text }}
        </v-snackbar>


        <v-dialog v-if="screen_data" v-model="screen_data.excel_pop_up" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="text-h6 primary__blue">Subir excel líneas</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="px-7">
                        <v-row>
                            <v-col align="center" class="pa-0">
                                <v-icon color="primary_blue" size="55" class="material-symbols-outlined"> table_chart
                                </v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pt-0" align="center">
                                <span class="text-h6 primary__blue">Orden Cabecera</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col align="center">
                                <p class="mb-0">Necesitamos la siguiente estructura</p>
                                <p class="font-weight-bold">Descripción / Precio unitario / Cantidad / Tipo
                                    <span v-if="screen_data.invoice && screen_data.invoice.tax_type"> {{screen_data.invoice.tax_type.toUpperCase()}}</span> *
                                </p>
                                <div class="d-flex flex-column align-center text-center mt-2" role="note">
                                    <div class="d-flex align-center">
                                        <span id="excel-tax-help" class="grey--text text--darken-1 caption mr-1">
                                            Indicaciones: use valor numérico (ej. 0.10), no el porcentaje
                                        </span>
                                        <v-tooltip bottom open-on-hover open-on-click>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    small
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    aria-label="Información sobre tipos de impuesto"
                                                    :aria-describedby="'excel-tax-help excel-optional-note'">
                                                    <v-icon color="primary_blue">mdi-information-outline</v-icon>
                                                </v-btn>
                                            </template>

                                            <div style="max-width: 320px;">
                                                <p class="font-weight-bold mb-2">Ej.: 10% → escriba 0.10</p>

                                                <!-- IVA -->
                                                <template v-if="!screen_data.invoice || screen_data.invoice.tax_type !== 'igic'">
                                                    <p class="subtitle-2 mb-1">Valores IVA:</p>
                                                    <v-simple-table dense>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">Descripción</th>
                                                                <th class="text-left">Valor numérico</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr><td>0%</td>          <td class="font-weight-bold">0.00</td></tr>
                                                            <tr><td>4%</td>          <td class="font-weight-bold">0.04</td></tr>
                                                            <tr><td>5%</td>          <td class="font-weight-bold">0.05</td></tr>
                                                            <tr><td>10%</td>         <td class="font-weight-bold">0.10</td></tr>
                                                            <tr><td>21%</td>         <td class="font-weight-bold">0.21</td></tr>
                                                            <tr><td>4% RE 0.5%</td>  <td class="font-weight-bold">0.005</td></tr>
                                                            <tr><td>10% RE 1.4%</td> <td class="font-weight-bold">0.014</td></tr>
                                                            <tr><td>21% RE 5.2%</td> <td class="font-weight-bold">0.052</td></tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </template>

                                                <!-- IGIC -->
                                                <template v-else>
                                                    <p class="subtitle-2 mb-1">Valores IGIC:</p>
                                                    <v-simple-table dense>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">Descripción</th>
                                                                <th class="text-left">Valor numérico</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr><td>0%</td>  <td class="font-weight-bold">0.00</td></tr>
                                                            <tr><td>3%</td>  <td class="font-weight-bold">0.03</td></tr>
                                                            <tr><td>5%</td>  <td class="font-weight-bold">0.05</td></tr>
                                                            <tr><td>7%</td>  <td class="font-weight-bold">0.07</td></tr>
                                                            <tr><td>15%</td> <td class="font-weight-bold">0.15</td></tr>
                                                            <tr><td>20%</td> <td class="font-weight-bold">0.20</td></tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </template>
                                            </div>
                                        </v-tooltip>
                                    </div>

                                    <div id="excel-optional-note" class="grey--text text--darken-1 caption mt-1" aria-live="off">
                                        Nota: los campos marcados con <strong>*</strong> son opcionales.
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-file-input class="rounded-lg" label="Archivo" v-model="screen_data.file"
                                    prepend-icon="mdi-paperclip" color="primary" accept=" .xls, .xlsx, .xlsm, .ods"
                                    :clearable="false" :loading="false" :rules="[v => !!v || 'Archivo requerido']"
                                    :error="error_upload_file" outlined></v-file-input>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.cancel_pop_up()" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="screen_data.confirm_pop_up()"
                        :disabled="!screen_data.file">
                        Subir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-if="screen_data" v-model="screen_data.delete_all_lines_pop_up" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="primary__blue">Eliminar Lineas</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <span class="mt-2 text-subtitle-1">¿Está seguro que desea eliminar todas las líneas?</span>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.cancel_pop_up()" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="screen_data.confirm_pop_up()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="screen_data && screen_data.invoice" v-model="viewer_dialog" content-class="invoice_right_viewer"
            max-height="100vh" overlay-color="primary_blue">
            <div>
                <StaticInvoiceViewer v-if="screen_data.invoice" :configuration="screen_data.configuration"
                    :invoice="screen_data.invoice" :rectified_inv="screen_data.rectificative_invoice"
                    :key="screen_data.invoice.toString()">
                </StaticInvoiceViewer>
            </div>
        </v-dialog>

        <v-dialog v-model="screen_data.reject_dialog" persistent max-width="500">
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">Rechazar factura</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <v-text-field outlined label="Motivo del rechazo" dense hide-details
                        v-model="screen_data.reject_comment"></v-text-field>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="previewRejectDialog(false)" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" :loading="screen_data.loading_reject" class="white--text action__btn" @click="rejectInvoice()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.send_dialog" v-if="screen_data.invoice" max-width="800">
            <v-card>
                <v-card-title class="headline">
                    <span class="text-h5 primary__blue py-1 ml-2">Opciones de envío</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="pl-2">
                        <v-radio-group v-model="screen_data.senderOption" row>
                            <v-radio v-if="sendable && screen_data.invoice.actions.includes('can_send_faceb2b2') && !screen_data.configuration.hide_client_send_to_faceb2b" label="FACEB2B" value="FACEB2B"></v-radio>
                            <v-radio v-if="sendable && screen_data.invoice.actions.includes('can_send_face') && !screen_data.configuration.hide_client_send_to_face" label="FACE" value="FACE"></v-radio>
                            <v-radio v-if="screen_data.invoice.actions.includes('can_send_email')" label="EMAIL" value="EMAIL"></v-radio>
                            <v-radio v-if="screen_data.invoice.actions.includes('can_send_accounting') && !screen_data.configuration.hide_client_send_to_accounting" label="MÓDULO CONTABILIDAD" value="CONT"></v-radio>
                        </v-radio-group>
                    </v-row>

                    <SendByEmailForm
                    v-if="screen_data.senderOption == 'EMAIL'"
                    :email_to.sync="screen_data.emailForm.to"
                    :subject.sync="screen_data.emailForm.subject"
                    :body.sync="screen_data.emailForm.body"
                    ></SendByEmailForm>

                    <v-row v-else-if="screen_data.senderOption == 'CONT' && screen_data.invoice.accounting_document_id">
                        <v-col cols="12">
                            <p>Factura ya enviada al módulo de contabilidad.
                                <!-- <a @click="goToDocument()">Enlace</a> -->
                            </p>
                        </v-col>
                    </v-row>
                    <v-row
                        v-else-if="screen_data.senderOption == 'CONT' && (
                            (screen_data.invoice.total_taxes_withheld && screen_data.invoice.total_taxes_withheld.length > 1) ||
                            (screen_data.invoice.retention_amount && screen_data.invoice.total_taxes_withheld && screen_data.invoice.total_taxes_withheld.length > 0)
                        )">
                        <v-col cols="12">
                            <p>El módulo de contabilidad no soporta múltiples retenciones.</p>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="mr-4">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="cancelSend()" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="sendInvoice()" :disabled="canSend" :loading="screen_data.send_loading">
                        Enviar
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.paid_dialog" persistent max-width="500" v-if="screen_data.invoice">
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">Aceptar factura</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p v-if="['budget', 'delivery_note'].includes(invoiceable_type)">Esta acción marcará el {{screen_data.invoice.name}} como aceptado.</p>
                    <p v-else>Esta acción marcará la factura como pagada.</p>
                    <p class="my-0">¿Desea continuar?</p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="previewPayDialog(false)" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" :loading="screen_data.paid_loading" class="white--text action__btn" @click="markAsAccepted()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- <app-confirm-modal v-model="screen_data.paid_dialog" :text-msg="'Esta acción marcará la factura como pagada.'"
            @confirm="markAsAccepted()" @cancel="previewPayDialog(false)" :textQuestion="'¿Desea continuar?'"
            :loading="screen_data.paid_loading">
        </app-confirm-modal> -->

        <v-dialog v-model="screen_data.showErrorsDialog" class="pa-0 ma-0 rounded" width="350px">
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-space-between">
                    <span class="px-4">Atención</span>
                    <v-btn icon @click="screen_data.setErrorDialog(false)">
                        <v-icon color="white" class="material-symbols-outlined">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-12">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined">warning</v-icon>
                            <span class="text-subtitle-1 font-weight-bold">Información incompleta</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span v-if="screen_data.errorDialogMessage">{{ screen_data.errorDialogMessage }}</span>
                            <span v-else>Por favor, <strong>revise los campos pendientes</strong> y complete la información
                                necesaria para poder firmar la factura.</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.showErrorExcelDialog" class="pa-0 ma-0 rounded" width="350px">
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-space-between">
                    <span class="px-4">Atención</span>
                    <v-btn icon @click="screen_data.setErrorExcelDialog(false)">
                        <v-icon color="white" class="material-symbols-outlined">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-12">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined">warning</v-icon>
                            <span class="text-subtitle-1 font-weight-bold">Error en la carga del excel</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span>{{ screen_data.error_excel_message }}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.showErrorSendDialog" class="pa-0 ma-0 rounded" width="350px">
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-space-between">
                    <span class="px-4">Error de envío</span>
                    <v-btn icon @click="screen_data.setErrorSendDialog(false)">
                        <v-icon color="white" class="material-symbols-outlined">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-12">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined">error</v-icon>
                            <span class="text-subtitle-1 font-weight-bold">Error al enviar</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span>{{ screen_data.error_send_message }}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.showRefreshDialog" class="pa-0 ma-0 rounded" width="400px" persistent>
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-center">
                    <span class="px-4">Documento modificado</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-8">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#FF9800" class="material-symbols-outlined">warning</v-icon>
                            <span class="text-subtitle-1 font-weight-bold mt-3">Atención</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span>{{ screen_data.refresh_message }}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pb-4 px-6 justify-center">
                    <v-btn color="primary" @click="reloadPage">
                        Recargar página
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="screen_data.downloadPopup" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">
                    <span class="text-h5 primary__blue py-1 ml-2" color="">Descargar factura</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <span>Tipo de extensión:</span>
                    <v-select
                        :items="screen_data.download_options"
                        v-model="screen_data.download_type"
                        outlined
                        dense
                        hide-details
                        icon="mdi-file-download-outline"
                        item-text="text" item-value="value"
                    >
                    </v-select>
                </v-card-text>
                <v-card-actions class="pr-8 pb-5">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="cancelDownload()" class="action__btn">Cancelar</v-btn>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="downloadInvoice()"
                        :disabled="!screen_data.download_type"
                        :loading="screen_data.download_loading">
                        Descargar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.confirmSignDialog" persistent max-width="500" v-if="screen_data.invoice"> 
            <v-card class="rounded-xl">
                <v-card-title>
                    <span class="primary__blue">
                        <span
                            v-if="screen_data.invoice.actions.includes('can_sign')"
                            class="text-h5 py-1 ml-2">Firmar y emitir {{ screen_data.invoice.name }}
                        </span>
                        <span
                            v-else
                            class="text-h5 py-1 ml-2">Emitir {{ screen_data.invoice.name }}
                        </span>
                    </span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p>Esta acción marcará
                        <span v-if="screen_data.invoice.actions.includes('can_sign')">la {{ screen_data.invoice.name }} como firmada</span>
                        <span v-else>el {{screen_data.invoice.name}} como emitido</span>
                        y ya no se podrá hacer ninguna modificación</p>
                    <v-alert
                        v-if="got_feature('feature_invoice_operation_date') && screen_data.invoice.invoice_date !== getTodayDate()"
                        dense
                        border="left"
                        colored-border
                        color="info"
                        elevation="0"
                        class="mt-3"
                        icon="mdi-information"
                        role="alert"
                        aria-live="polite"
                    >
                        La fecha de {{ screen_data.invoice.name }} se actualizará a la fecha de hoy.
                    </v-alert>
                    <v-alert
                        v-if="screen_data.has_prev_draft_invoices"
                        dense
                        border="left"
                        colored-border
                        color="amber darken-2"
                        elevation="0"
                        class="mt-3"
                        icon="mdi-alert"
                        role="alert"
                        aria-live="polite"
                    >
                        Tiene borradores con fecha inferior a la fecha de
                        <span v-if="screen_data.invoice.actions.includes('can_sign')">esta</span>
                        <span v-else>este</span>
                        {{ screen_data.invoice.name }}.
                    </v-alert>
                    <p class="my-0">¿Desea continuar?</p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="previewSignDialog(false)" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="confirmSignInvoice()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.showErrorsDialogVerifactu" class="pa-0 ma-0 rounded" width="350px">
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-space-between">
                <span class="px-4">Atención</span>
                <v-btn icon @click="screen_data.setErrorDialogVerifactu(false)">
                    <v-icon color="white" class="material-symbols-outlined">close</v-icon>
                </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-12">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined">warning</v-icon>
                            <span class="text-subtitle-1 font-weight-bold">
                                {{ screen_data.errorDialogMessage }}
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="d-flex justify-center mt-4">
                            <v-btn
                                icon class="ml-1" small
                                @click="$router.push({ 'name': 'invoice-history-list', 'params': { 'companydb_id': companydb_id }})"
                                v-if="screen_data.invoice && screen_data.invoice.name === 'ok'"
                                >
                                Registro de facturas
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>



        <!-- Inicio pantalla -->
        <template v-if="screen_data.invoice && screen_data.invoice.kind != 'in_invoice'">
            <!-- Cabecera -->
            <v-row
                :class="{
                    'mx-1': is_mobile,
                    'mx-2': !is_mobile,
                    'pa-0': true
                }"
                v-if="!is_mobile"
            >
                <v-col cols="3">
                    <div class="mr-0 d-flex align-center">
                        <v-btn v-if="companydb_id" icon
                            @click="backToList()">
                            <AppIcon :src="require('../../../assets/back-arrow.svg')" :size="29" />
                        </v-btn>
                        <h3 class="primary_blue--text ml-1" v-if="is_tablet">Editor</h3>
                        <h3 class="primary_blue--text ml-2 " v-else>Editor de {{ screen_data.invoice.name }}</h3>
                    </div>
                </v-col>
                <v-spacer/>
                <v-col cols="3">
                    <template v-if="screen_data && !screen_data.loading">
                        <div class="d-flex justify-space-between px-2 mx-2 my-1 py-0 flex-grow-1" v-if="screen_data.invoice && is_mobile">
                            <div class="d-flex align-center rounded-pill grey lighten-2 px-2 py-1 flex-grow-1">
                              <p class="ma-0 pa-0">{{ invoice_state }}</p>
                              <v-icon :color="getStateIndicatorClass()" dense class="ml-2" small>mdi-circle</v-icon>
                            </div>
                          </div>
                        <div class="rounded-pill grey lighten-3 py-0 d-inline-flex align-sm-center flex-sm-nowrap invoice_state"
                            v-else-if="screen_data.invoice">
                            <div class="text--grey--darken-3 mr-2 pl-4 font-weight-medium" v-if="!is_mobile">Estado:
                            </div>
                            <div
                                class="d-flex justify-space-between rounded-pill white px-2 mx-2 my-1 py-0 flex-grow-1">
                                <p class="ma-0 pa-0">{{ invoice_state }} </p>
                                <v-icon :color="getStateIndicatorClass()" dense small>mdi-circle</v-icon>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <v-progress-circular indeterminate class="mr-2" color="primary"></v-progress-circular>
                    </template>
                </v-col>
                <v-spacer/>
                <template v-if="screen_data.invoice.actions.includes('has_paid_state')">
                    <v-col cols="3"
                        v-if="(temp_payment_state == '' && paymentStateToShow) || paymentStateToShow == 'Rectificada'">
                        <template v-if="screen_data && !screen_data.loading">
                            <div class="rounded-pill grey lighten-3 py-0 d-inline-flex align-sm-center flex-sm-nowrap invoice_state"
                                v-if="screen_data.invoice">
                                <div class="text--grey--darken-3 mr-2 pl-4 font-weight-medium text-no-wrap">Estado de pago:
                                </div>
                                <div
                                    class="d-flex justify-space-between rounded-pill white px-2 mx-1 my-1 py-0 flex-grow-1">
                                    <p class="ma-0 pa-0">{{ paymentStateToShow }} </p>
                                    <v-icon :color="getPaymentStateIndicatorClass()" dense small>mdi-circle</v-icon>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <v-progress-circular indeterminate class="mr-2" color="primary"></v-progress-circular>
                        </template>
                    </v-col>
                    <v-col cols="3" v-else-if="paymentStateToShow">
                        <template v-if="screen_data && !screen_data.loading">
                            <div class="rounded-pill grey lighten-3 py-0 d-inline-flex align-sm-center flex-sm-nowrap invoice_state"
                                v-if="screen_data.invoice">
                                <div class="text--grey--darken-3 mr-0 pl-4 font-weight-medium text-no-wrap">Estado de pago:
                                </div>
                                <div
                                    class="d-flex justify-space-between rounded-pill white px-2 mx-1 my-1 py-0 flex-grow-1">
                                    <p class="ma-0 pa-0 custom-select">
                                        <v-autocomplete :items="computed_payment_states" v-model="temp_payment_state"
                                            item-text="name" item-value="value" filled hide-details flat solo dense
                                            background-color="transparent" @change="dirtyPaymentState=true"></v-autocomplete>
                                    </p>
                                    <v-icon :color="getPaymentStateIndicatorClass()" dense small>mdi-circle</v-icon>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <v-progress-circular indeterminate class="mr-2" color="primary"></v-progress-circular>
                        </template>
                    </v-col>
                </template>
                <v-spacer/>
                <template v-if="screen_data.invoice.actions.includes('can_mark_as_accepted_or_rejected') && !['draft', 'accepted', 'b_rejected', 'invoiced'].includes(screen_data.invoice.state)">
                    <v-col cols="2" class="d-flex justify-end align-center" v-if="!is_tablet">
                        <v-row class="ma-0 pa-0 flex-sm-nowrap">
                            <v-col class="ma-0 pa-0">
                                <div
                                    class="rounded-pill grey lighten-3 py-0 d-inline-flex align-sm-center btn_pointer invoice_state"
                                    @click="previewPayDialog(true)">
                                    <span class="text--grey mr-2 pl-4 font-weight-medium text-no-wrap">
                                        Aceptado
                                    </span>
                                    <v-spacer/>
                                    <v-btn icon class="ml-1" small >
                                        <AppIcon :src="require('../../../assets/mark_as_paid.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                    </v-btn>
                                </div>
                            </v-col>
                            <v-col class="ma-0 pa-0 pl-3">
                                <div
                                    class="rounded-pill grey lighten-3 py-0 d-inline-flex align-sm-center flex-sm-nowrap btn_pointer invoice_state"
                                    @click="previewRejectDialog(true)">
                                    <span class="text--grey mr-2 pl-4 font-weight-medium text-no-wrap">
                                        Rechazado
                                    </span>
                                    <v-spacer></v-spacer>
                                    <v-btn icon class="ml-1" small >
                                        <AppIcon :src="require('../../../assets/mark_as_rejected.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="3" class="d-flex justify-end align-center" v-else>
                        <v-row class="ma-0 pa-0 flex-sm-nowrap">
                            <v-col class="ma-0 pa-0">
                                <v-btn icon class="ml-1" small @click="previewPayDialog(true)">
                                    <AppIcon :src="require('../../../assets/mark_as_paid.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </v-col>
                            <v-col class="ma-0 pa-0 pl-3">
                                <v-btn icon class="ml-1" small @click="previewRejectDialog(true)">
                                    <AppIcon :src="require('../../../assets/mark_as_rejected.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </template>
                <v-spacer/>
                <template v-if="screen_data && screen_data.invoice && !is_mobile">
                    <v-col cols="3" class="d-flex justify-end align-center">
                        <template v-if="invoiceable_id && screen_data.invoiceableIdList">
                            <v-btn icon :disabled="!canGoLeft" @click="goLeft()" small>
                                <v-icon size="48" color="primary_blue" class="material-symbols-outlined">chevron_left</v-icon>
                            </v-btn>
                            <v-btn icon :disabled="!canGoRight" @click="goRight()" small>
                                <v-icon size="48" color="primary_blue" class="material-symbols-outlined">chevron_right</v-icon>
                            </v-btn>
                        </template>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="ml-1"
                                    icon
                                    @click="newInvoiceable()"
                                    :disabled="!screen_data.hasActiveContract"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <AppIcon
                                        :src="require('@/assets/add_box.svg')"
                                        :size="29"
                                        :colorMap="{ '060647': screen_data.hasActiveContract ? 'primary_blue' : 'primary_gray' }"
                                    />
                                </v-btn>
                            </template>
                            <span>Crear {{ screen_data.invoice.name }}</span>
                        </v-tooltip>
                        <JobProgress
                            class="d-flex justify-center"
                            v-model="screen_data.asyncJobState"
                            @done="jobDone"
                            :job_id="screen_data.asyncJobId"
                            :divStyle="'max-width: min-content;'"
                            @error="showErrorAsyncjob">
                            <template v-slot:progress>
                                <v-btn
                                    icon
                                    v-if="screen_data.asyncJobState==='running'"
                                    color="primary__blue"
                                    :loading="true"
                                >
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                            </template>
                            <template v-slot:[stateSlot]>
                                <v-tooltip bottom v-if="screen_data.invoice.actions.includes('can_download')">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="ml-1" icon @click="screen_data.downloadPopup=true" v-bind="attrs" v-on="on">
                                            <AppIcon 
                                                :src="require('@/assets/download_xml.svg')"
                                                :size="29"
                                                :colorMap="{ '060647': 'primary_blue' }"/>
                                        </v-btn>
                                    </template>
                                    <span>Descargar {{ screen_data.invoice.name }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="ml-1" icon @click="openSendDialog()"
                                            :disabled="!sendable && !mail_sendable" v-bind="attrs" v-on="on">

                                            <AppIcon :src="require('@/assets/send_invoice.svg')" :size="29" v-if="sendable || mail_sendable" :colorMap="{ '060647': 'primary_blue' }" />
                                            <AppIcon :src="require('@/assets/send_invoice_disabled.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                        </v-btn>
                                    </template>
                                    <span>Enviar  {{ screen_data.invoice.name }}</span>
                                </v-tooltip>
                            </template>
                        </JobProgress>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="ml-1" icon @click="saveInvoice()"
                                    :disabled="cantSave || screen_data.loading" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('@/assets/save_invoice_disabled.svg')" :size="29" v-if="cantSave || screen_data.loading" :colorMap="{ '060647': 'primary_blue' }"/>
                                    <AppIcon :src="require('@/assets/save_invoice.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Guardar {{ screen_data.invoice.name }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    class="ml-1" 
                                    icon 
                                    @click="signInvoice()" 
                                    :disabled="!screen_data.hasActiveContract || !editable || screen_data.loading" 
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <AppIcon :src="require('@/assets/sign_invoice.svg')" :size="29" v-if="screen_data.hasActiveContract && editable && !screen_data.loading" :colorMap="{ '060647': 'primary_blue' }"/>
                                    <AppIcon :src="require('@/assets/sign_invoice_disabled.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_gray' }"/>
                                </v-btn>
                            </template>
                            <span v-if="screen_data.invoice.actions.includes('can_sign')">Firmar y emitir</span>
                            <span v-else>Emitir</span>
                        </v-tooltip>
                        <!-- <v-tooltip bottom v-if="false">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="ml-2" icon @click="previewInvoice()" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('../../../assets/view_invoice.svg')" :size="29" v-if="!viewer_dialog" />
                                    <AppIcon :src="require('../../../assets/hide_invoice.svg')" :size="29" v-else />
                                </v-btn>
                            </template>
                            <span>Visualizar  {{ screen_data.invoice.name }}</span>
                        </v-tooltip> -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="ml-1" icon @click="openToPrint()" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('@/assets/view_invoice.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Visualizar  {{ screen_data.invoice.name }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="screen_data.invoice.source_odoc_id">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="ml-1" icon @click="goToOtherDocument()" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('@/assets/documents2.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Ir a documento original</span>
                        </v-tooltip>
                    </v-col>
                </template>
                <v-col v-else-if="screen_data && screen_data.invoice && is_mobile" cols="2" class="d-flex justify-center">
                    <div id="menu-anchor">
                        <v-menu
                            v-model="speedDial"
                            bottom
                            transition="scale-transition"
                            offset-y
                            content-class="transparent-menu"
                            attach="#menu-anchor"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('@/assets/btn-show-menu.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>

                            <v-list class="transparent-list justify-cente">
                                <v-list-item class="d-flex justify-center">
                                    <JobProgress
                                        v-model="screen_data.asyncJobState"
                                        @done="jobDone"
                                        :job_id="screen_data.asyncJobId"
                                        :divStyle="'max-width: min-content;'"
                                        @error="showErrorAsyncjob"
                                        >
                                        <template #progress>
                                            <v-btn
                                            icon
                                            v-if="screen_data.asyncJobState === 'running'"
                                            color="primary__blue"
                                            :loading="true"
                                            >
                                            <v-icon>mdi-refresh</v-icon>
                                            </v-btn>
                                        </template>
                                        <template  v-slot:[stateSlot]>
                                            <v-tooltip left v-if="screen_data.invoice.actions.includes('can_download')">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon @click="screen_data.downloadPopup = true" v-bind="attrs" v-on="on">
                                                    <AppIcon :src="require('@/assets/download_xml.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                                    </v-btn>
                                                </template>
                                                <span>Descargar  {{ screen_data.invoice.name }}</span>
                                            </v-tooltip>
                                            <v-tooltip left>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon @click="openSendDialog()" :disabled="!sendable && !mail_sendable" v-bind="attrs" v-on="on">
                                                    <AppIcon :src="require('@/assets/send_invoice.svg')" :size="29" v-if="sendable || mail_sendable" :colorMap="{ '060647': 'primary_blue' }"/>
                                                    <AppIcon :src="require('@/assets/send_invoice_disabled.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                                    </v-btn>
                                                </template>
                                                <span>Enviar  {{ screen_data.invoice.name }}</span>
                                            </v-tooltip>
                                        </template>
                                    </JobProgress>
                                </v-list-item>

                                <v-list-item class="d-flex justify-center">
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click="saveInvoice()" :disabled="(!editable && !dirtyPaymentState) || screen_data.loading" v-bind="attrs" v-on="on">
                                            <AppIcon :src="require('@/assets/save_invoice_disabled.svg')" :size="29" v-if="(!editable && !dirtyPaymentState) || screen_data.loading" :colorMap="{ '060647': 'primary_blue' }"/>
                                            <AppIcon :src="require('@/assets/save_invoice.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                            </v-btn>
                                        </template>
                                        <span>Guardar  {{ screen_data.invoice.name }}</span>
                                    </v-tooltip>
                                </v-list-item>

                                <v-list-item class="d-flex justify-center">
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn 
                                                icon 
                                                @click="signInvoice()" 
                                                :disabled="!screen_data.hasActiveContract || !editable || screen_data.loading" 
                                                v-bind="attrs" 
                                                v-on="on"
                                            >
                                            <AppIcon :src="require('@/assets/sign_invoice.svg')" :size="29" v-if="screen_data.hasActiveContract && editable && !screen_data.loading" :colorMap="{ '060647': 'primary_blue' }"/>
                                            <AppIcon :src="require('@/assets/sign_invoice_disabled.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_gray' }"/>
                                            </v-btn>
                                        </template>
                                        <span v-if="screen_data.invoice.actions.includes('can_sign')">Firmar y emitir</span>
                                        <span v-else>Emitir</span>
                                    </v-tooltip>
                                </v-list-item>

                                <!-- <v-list-item v-if="false" class="d-flex justify-center">
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click="previewInvoice()" v-bind="attrs" v-on="on">
                                            <AppIcon :src="require('../../../assets/view_invoice.svg')" :size="29" v-if="!viewer_dialog" />
                                            <AppIcon :src="require('../../../assets/hide_invoice.svg')" :size="29" v-else />
                                            </v-btn>
                                        </template>
                                        <span>Visualizar  {{ screen_data.invoice.name }}</span>
                                    </v-tooltip>
                                </v-list-item> -->

                                <v-list-item class="d-flex justify-center">
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click="openToPrint()" v-bind="attrs" v-on="on">
                                            <AppIcon :src="require('@/assets/view_invoice.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                            </v-btn>
                                        </template>
                                        <span>Visualizar  {{ screen_data.invoice.name }}</span>
                                    </v-tooltip>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </v-col>
                <template v-else>
                    <v-progress-circular indeterminate class="mr-2" color="primary"/>
                </template>
            </v-row>

            <!-- Cabecera formato móvil -->
            <v-row
                v-if="is_mobile"
                class="pa-0 d-flex align-center justify-space-between"
                style="position: sticky; top: 0; z-index: 2; background-color: white; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);"
                >
                <!-- Botón atrás + Título -->
                <v-col cols="8" class="d-flex flex-row align-center">
                    <v-btn icon v-if="companydb_id" @click="backToList()">
                    <AppIcon :src="require('@/assets/back-arrow.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                    </v-btn>
                    <h3 class="primary_blue--text ml-2" style="font-size: 24px;">Editor</h3>
                </v-col>

                <!-- Botón menú -->
                <v-col cols="4" class="d-flex justify-end px-8">
                    <div id="menu-anchor">
                    <v-menu
                        v-model="speedDial"
                        bottom
                        transition="scale-transition"
                        offset-y
                        content-class="transparent-menu"
                        attach="#menu-anchor"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <AppIcon :src="require('@/assets/btn-show-menu.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                        </v-btn>
                        </template>

                        <v-list class="transparent-list justify-center">
                        <v-list-item class="d-flex justify-center">
                            <JobProgress
                            v-model="screen_data.asyncJobState"
                            @done="jobDone"
                            :job_id="screen_data.asyncJobId"
                            :divStyle="'max-width: min-content;'"
                            @error="showErrorAsyncjob"
                            >
                            <template #progress>
                                <v-btn icon v-if="screen_data.asyncJobState === 'running'" color="primary__blue" :loading="true">
                                <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:[stateSlot]>
                                <v-tooltip left v-if="screen_data.invoice.actions.includes('can_download')">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click="screen_data.downloadPopup = true" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('@/assets/download_xml.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                    </v-btn>
                                </template>
                                <span>Descargar {{ screen_data.invoice.name }}</span>
                                </v-tooltip>
                                <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click="openSendDialog()" :disabled="!sendable && !mail_sendable" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('@/assets/send_invoice.svg')" :size="29" v-if="sendable || mail_sendable" :colorMap="{ '060647': 'primary_blue' }"/>
                                    <AppIcon :src="require('@/assets/send_invoice_disabled.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                    </v-btn>
                                </template>
                                <span>Enviar {{ screen_data.invoice.name }}</span>
                                </v-tooltip>
                            </template>
                            </JobProgress>
                        </v-list-item>

                        <v-list-item class="d-flex justify-center">
                            <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon @click="saveInvoice()" :disabled="(!editable && !dirtyPaymentState) || screen_data.loading" v-bind="attrs" v-on="on">
                                <AppIcon :src="require('@/assets/save_invoice_disabled.svg')" :size="29" v-if="(!editable && !dirtyPaymentState) || screen_data.loading" :colorMap="{ '060647': 'primary_blue' }"/>
                                <AppIcon :src="require('@/assets/save_invoice.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Guardar {{ screen_data.invoice.name }}</span>
                            </v-tooltip>
                        </v-list-item>

                        <v-list-item class="d-flex justify-center">
                            <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon @click="signInvoice()" :disabled="!screen_data.hasActiveContract || !editable || screen_data.loading" v-bind="attrs" v-on="on">
                                <AppIcon :src="require('@/assets/sign_invoice.svg')" :size="29" v-if="screen_data.hasActiveContract && editable && !screen_data.loading" :colorMap="{ '060647': 'primary_blue' }"/>
                                <AppIcon :src="require('@/assets/sign_invoice_disabled.svg')" :size="29" v-else :colorMap="{ '060647': 'primary_gray' }"/>
                                </v-btn>
                            </template>
                            <span v-if="screen_data.invoice.actions.includes('can_sign')">Firmar y emitir</span>
                            <span v-else>Emitir</span>
                            </v-tooltip>
                        </v-list-item>

                        <v-list-item class="d-flex justify-center">
                            <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon @click="openToPrint()" v-bind="attrs" v-on="on">
                                <AppIcon :src="require('@/assets/view_invoice.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Visualizar {{ screen_data.invoice.name }}</span>
                            </v-tooltip>
                        </v-list-item>
                        </v-list>
                    </v-menu>
                    </div>
                </v-col>

                <!-- Panel de estados en versión móvil -->
                <v-col
                class="pt-2"
                style="width: fit-content; display: inline-block;"
                >
                <v-expansion-panels>
                    <v-expansion-panel>

                        <v-expansion-panel-header
                            class="d-flex align-center justify-space-between"
                            style="padding: 12px 16px;"
                        >
                            <p class="ma-0" style="font-size: 20px; font-weight: bold; width: fit-content;">
                            Estados
                            </p>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                            <div class="d-flex flex-column" style="row-gap: 8px;">
                                <!-- Estado factura -->
                                <div
                                    class="d-flex align-center justify-space-between rounded-pill grey lighten-3 px-3 py-1"
                                    style="padding:9px !important;"
                                    >
                                    <p  class="ma-0 pa-0"
                                        style=" font-size: 18px !important;
                                                font-weight: 400 !important;
                                                margin-left: 12px !important;"
                                    >
                                    {{ invoice_state }}
                                    </p>
                                    <v-icon
                                    :color="getStateIndicatorClass()"
                                    dense
                                    small
                                    class="mr-2"
                                    style="font-size: large"
                                    >
                                    mdi-circle
                                    </v-icon>
                                </div>

                                <v-divider class="mx-3" style="opacity: 0.4;" />

                                <!-- Estado de pago -->
                                <template v-if="screen_data.invoice.actions.includes('has_paid_state') && paymentStateToShow">
                                    <!--
                                    Opción A: Si el usuario puede editar el estado de pago:
                                    (Por ejemplo, si no está en 'draft' o si hay una condición particular.)
                                    -->
                                    <div v-if="!editable && paymentStateToShow && screen_data.invoice.state !== 'draft'"
                                        class="d-flex align-center justify-space-between rounded-pill grey lighten-3 px-3 py-1"
                                        style="gap: 8px;"
                                    >
                                    <!-- v-autocomplete para escoger estado de pago -->
                                    <v-autocomplete
                                        :items="computed_payment_states"
                                        v-model="temp_payment_state"
                                        item-text="name"
                                        item-value="value"
                                        filled
                                        hide-details
                                        flat
                                        solo
                                        dense
                                        background-color="transparent"
                                        @change="dirtyPaymentState = true"
                                        style="min-width: 120px; font-size: large;"
                                    ></v-autocomplete>

                                    <v-icon
                                        :color="getPaymentStateIndicatorClass()"
                                        dense
                                        small
                                        class="mr-2"
                                        style="font-size: large"
                                    >
                                        mdi-circle
                                    </v-icon>
                                    </div>

                                    <!--
                                    Opción B: Si el usuario NO puede editar el estado (solo lo ve).
                                    -->
                                    <div v-else class="d-flex align-center justify-space-between rounded-pill grey lighten-3 px-3 py-1">
                                        <p
                                            class="ma-0 pa-0 text-no-wrap"
                                            style=" font-size: large;
                                                    font-weight: 400 !important;
                                                    margin-left: 12px !important;"
                                            >
                                            {{ paymentStateToShow }}
                                        </p>
                                        <v-icon
                                            :color="getPaymentStateIndicatorClass()"
                                            dense
                                            small
                                            class="mr-2"
                                            style="font-size:large"
                                        >
                                            mdi-circle
                                        </v-icon>
                                    </div>
                                </template>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                </v-col>
            </v-row>

            <!-- <p>{{screen_data.selectedSequence}}</p>
            <p>{{screen_data.configuration}}</p>
            <p>---{{this.next_number}}</p> -->


            <v-card class="sector-div">
                <v-row :class="{'ma-0': true, 'flex-sm-nowrap': !is_tablet }">
                    <v-col cols="12" md="12" class="px-0 py-0" :lg="invoiceable_type === 'ticket' ? 6 : 4">
                        <v-row class="sector-head">
                            <v-col cols="6" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0">
                                    Datos generales
                                    <span v-if="!is_mobile">
                                        {{ screen_data.invoice.name }}
                                    </span>
                                    <span v-if="screen_data.invoice.rectificative">
                                        rectificativa
                                    </span>
                                </p>
                            </v-col>
                            <v-col cols="6"
                                :class="{ 'px-1': is_tablet, 'py-0 pr-8': true }"
                                class="d-flex align-center"
                                v-if="screen_data.configuration && !is_manual_invoice_number && screen_data.invoice.state == 'draft' && screen_data.invoice.name != 'proforma'">
                                <label class="mr-1" v-if="!is_mobile">Serie</label>
                                <v-select
                                    :items="screen_data.availableSequences"
                                    item-value="id"
                                    item-text="code"
                                    v-model="screen_data.invoice.sequence_id"
                                    @change="sequenceChanged"
                                    :disabled="!editable"
                                    outlined
                                    dense
                                    hide-details
                                    :style="{ backgroundColor: editable ? 'white' : '' }"
                                    :label="is_mobile ? 'Serie' : ''"
                                    >
                                </v-select>
                            </v-col>
                        </v-row>
                        <div :class="{ 'sector__input': true, 'pa-8': !is_mobile, 'px-8': is_mobile, 'py-3': is_mobile }">
                            <div>
                                <v-row>
                                    <v-col cols="6" md="4" sm="6" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <!-- Manual mode or non-editable invoice: always use invoice_number as editable/readonly -->
                                        <AppTextFieldV2 v-if="is_manual_invoice_number || !editable"
                                            :label="'Número ' + screen_data.invoice.name"
                                            v-model="screen_data.invoice.invoice_number"
                                            :readonly="!editable"
                                            :background_color="screen_data.showErrors && !screen_data.invoice.invoice_number ? '#DC0B0B1A' : ''"
                                            :error="screen_data.showErrors && !screen_data.invoice.invoice_number"
                                        />
                                        <!-- If invoice_number is already set in draft mode, prioritize it over predicted -->
                                        <AppTextFieldV2 v-else-if="screen_data.invoice.state == 'draft' && screen_data.invoice.invoice_number"
                                            :label="'Número ' + screen_data.invoice.name"
                                            v-model="screen_data.invoice.invoice_number"
                                            readonly
                                            class="custom-gray-text"
                                            :background_color="screen_data.showErrors && !screen_data.invoice.invoice_number ? '#DC0B0B1A' : ''"
                                            :error="screen_data.showErrors && !screen_data.invoice.invoice_number"
                                        />
                                        <!-- For rectificative without invoice number: use predicted_rectificative_invoice_number -->
                                        <AppTextFieldV2 v-else-if="screen_data.invoice.rectificative"
                                            :label="'Número ' + screen_data.invoice.name"
                                            v-model="screen_data.invoice.predicted_rectificative_invoice_number"
                                            readonly
                                            class="custom-gray-text"
                                            :background_color="screen_data.showErrors && !screen_data.invoice.predicted_rectificative_invoice_number ? '#DC0B0B1A' : ''"
                                            :error="screen_data.showErrors && !screen_data.invoice.predicted_rectificative_invoice_number"
                                        />
                                        <!-- General case: use predicted_invoice_number -->
                                        <AppTextFieldV2 v-else
                                            :label="'Número ' + screen_data.invoice.name"
                                            v-model="screen_data.invoice.predicted_invoice_number"
                                            readonly
                                            class="custom-gray-text"
                                            :background_color="screen_data.showErrors && !screen_data.invoice.predicted_invoice_number ? '#DC0B0B1A' : ''"
                                            :error="screen_data.showErrors && !screen_data.invoice.predicted_invoice_number"
                                        />
                                    </v-col>
                                    <v-col cols="3" md="4" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <v-menu
                                            ref="invoiceDateMenu"
                                            v-model="invoiceDateVisible"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            :disabled="!editable || ((invoiceable_type === 'invoice' || invoiceable_type === 'ticket') && (!got_feature('feature_invoice_date_editable') || (screen_data.configuration && screen_data.configuration.auto_send_to_verifactu)))"
                                        >
                                            <template v-if="screen_data.invoice.rectificative"
                                                v-slot:activator="{ on: menuOn }">

                                                <v-tooltip bottom
                                                    :disabled="!(screen_data.showErrors && (!screen_data.invoice.invoice_date
                                                        || (screen_data.selectedSequence.min_rectificative_inv_date != '' && screen_data.invoice.invoice_date < screen_data.selectedSequence.min_rectificative_inv_date)
                                                        || (screen_data.rectificative_invoice && screen_data.invoice.invoice_date < screen_data.rectificative_invoice.invoice_date)
                                                        || (screen_data.invoice.invoice_date < screen_data.invoice.rectificative_info.invoice_date)))">
                                                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                                        <AppTextFieldV2
                                                            :label="is_tablet ?  'F. ' + screen_data.invoice.name : 'Fecha ' + screen_data.invoice.name"
                                                            :value="formattedDate(screen_data.invoice.invoice_date)"
                                                            readonly
                                                            v-on="{ ...menuOn, ...tooltipOn }"
                                                            v-bind="tooltipAttrs"
                                                            :disabled="!editable || ((invoiceable_type === 'invoice' || invoiceable_type === 'ticket') && (!got_feature('feature_invoice_date_editable') || (screen_data.configuration && screen_data.configuration.auto_send_to_verifactu)))"
                                                            :background_color="(screen_data.showErrors && (!screen_data.invoice.invoice_date
                                                                || (screen_data.selectedSequence.min_rectificative_inv_date != '' && screen_data.invoice.invoice_date < screen_data.selectedSequence.min_rectificative_inv_date)
                                                                || (screen_data.rectificative_invoice && screen_data.invoice.invoice_date < screen_data.rectificative_invoice.invoice_date)
                                                                || (screen_data.invoice.rectificative && screen_data.invoice.invoice_date < screen_data.invoice.rectificative_info.invoice_date))) ? '#DC0B0B1A' : ''"
                                                            :error="(screen_data.showErrors && (!screen_data.invoice.invoice_date
                                                                || (screen_data.selectedSequence.min_rectificative_inv_date != '' && screen_data.invoice.invoice_date < screen_data.selectedSequence.min_rectificative_inv_date)
                                                                || (screen_data.rectificative_invoice && screen_data.invoice.invoice_date < screen_data.rectificative_invoice.invoice_date)
                                                                || (screen_data.invoice.invoice_date < screen_data.invoice.rectificative_info.invoice_date)))"
                                                            />
                                                    </template>
                                                    <span>No es posible crear un  {{ screen_data.invoice.name }} con fecha anterior a
                                                        <template v-if="screen_data.rectificative_invoice">
                                                            <span
                                                                v-if="(screen_data.selectedSequence.min_rectificative_inv_date != '' &&
                                                                    screen_data.selectedSequence.min_rectificative_inv_date > screen_data.rectificative_invoice.invoice_date)">
                                                                {{ formattedDate(screen_data.selectedSequence.min_rectificative_inv_date) }}
                                                            </span>
                                                            <span v-else>
                                                                {{ formattedDate(screen_data.rectificative_invoice.invoice_date) }}
                                                            </span>
                                                        </template>
                                                        <template v-else>
                                                            <span
                                                                v-if="(screen_data.selectedSequence.min_rectificative_inv_date != '' &&
                                                                    screen_data.selectedSequence.min_rectificative_inv_date > screen_data.invoice.invoice_date)">
                                                                {{ formattedDate(screen_data.selectedSequence.min_rectificative_inv_date) }}
                                                            </span>
                                                            <span v-else>
                                                                {{ formattedDate(screen_data.invoice.rectificative_info.invoice_date) }}
                                                            </span>
                                                        </template>
                                                    </span>
                                                </v-tooltip>
                                            </template>
                                            <template v-else v-slot:activator="{ on: menuOn }">
                                                <v-tooltip bottom
                                                    :disabled="!(screen_data.showErrors && (!screen_data.invoice.invoice_date || (screen_data.selectedSequence.min_inv_date != '' && screen_data.invoice.invoice_date < screen_data.selectedSequence.min_inv_date)))">
                                                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                                        <AppTextFieldV2
                                                            :label="is_tablet ?  'F. ' + screen_data.invoice.name : 'Fecha ' + screen_data.invoice.name"
                                                            :value="formattedDate(screen_data.invoice.invoice_date)"
                                                            readonly
                                                            v-on="got_feature('feature_invoice_operation_date') ? { ...tooltipOn } : { ...menuOn, ...tooltipOn }"
                                                            v-bind="tooltipAttrs"
                                                            :disabled="!editable || ((invoiceable_type === 'invoice' || invoiceable_type === 'ticket') && (!got_feature('feature_invoice_date_editable') || (screen_data.configuration && screen_data.configuration.auto_send_to_verifactu)))"
                                                            :background_color="screen_data.showErrors && (screen_data.selectedSequence.min_inv_date != '' && screen_data.invoice.invoice_date && screen_data.invoice.invoice_date < screen_data.selectedSequence.min_inv_date)? '#DC0B0B1A' : ''"
                                                            :error="           screen_data.showErrors && (screen_data.selectedSequence.min_inv_date != '' && screen_data.invoice.invoice_date && screen_data.invoice.invoice_date < screen_data.selectedSequence.min_inv_date)"
                                                        />
                                                    </template>
                                                    <span style="display:inline-block; max-width:200px; white-space:normal; text-align:center">
                                                        No es posible crear un {{ screen_data.invoice.name }} con fecha anterior a
                                                        {{ formattedDate(screen_data.selectedSequence.min_inv_date) }}
                                                    </span>
                                                </v-tooltip>
                                            </template>
                                            <v-date-picker v-model="screen_data.invoice.invoice_date" no-title
                                                @input="handleDateChange('invoice_date', 'invoiceDateVisible')"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="3" md="4" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                                                                <v-tooltip bottom :disabled="!isDueDateInvalid && !isDueDateBeforeToday">
                                            <template #activator="{ on, attrs }">
                                                <div v-on="on" v-bind="attrs">
                                                    <AppDateField
                                                        ref="dueDateMenu"
                                                        v-model="screen_data.invoice.invoice_due_date"
                                                        :label="is_tablet ?  'F. vencimiento' : 'Fecha vencimiento'"
                                                        :disabled="!editable"
                                                        :error="screen_data.showErrors && invoiceable_type == 'invoice' && !screen_data.invoice.invoice_due_date || isDueDateInvalid || isDueDateBeforeToday"
                                                        :background_color="screen_data.showErrors && invoiceable_type =='invoice' && !screen_data.invoice.invoice_due_date || isDueDateInvalid || isDueDateBeforeToday ? '#DC0B0B1A' : 'white'"
                                                        v-on="on"
                                                        v-bind="attrs"
                                                    />
                                                </div>
                                            </template>
                                            <span style="display:inline-block; max-width:160px; white-space:normal; text-align:center">
                                                <span v-if="isDueDateBeforeToday">La fecha de vencimiento no puede ser anterior a hoy.</span>
                                                <span v-else-if="isDueDateInvalid">La fecha de vencimiento no puede ser anterior a la fecha de {{screen_data.invoice.name}}.</span>
                                            </span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="3" md="4" :class="{ 'px-1': is_tablet, 'py-0': true }" v-if="got_feature('feature_invoice_operation_date')">
                                        <AppDateField
                                            ref="operationDateMenu"
                                            v-model="screen_data.invoice.operation_date"
                                            :label="is_tablet ? 'F. operación' : 'Fecha operación'"
                                            :disabled="!editable"
                                            :max="getTodayDate()"
                                        />
                                    </v-col>
                                </v-row>

                                <v-row class="mt-2">
                                    <v-col cols="6" md="4" :class="{ 'px-1': is_tablet, 'py-0': true }" v-if="screen_data.invoice.type == 'invoice'">
                                        <AppTextFieldV2 label="Número factura externo" v-model="screen_data.invoice.external_invoice_number" readonly/>
                                    </v-col>
                                    <v-col cols="3" md="4" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <AppDateField
                                            ref="invoiceStartDate"
                                            :label="is_tablet ? 'F. inicio' : 'Fecha inicio'"
                                            v-model="screen_data.invoice.start_date"
                                            :disabled="!editable"
                                        />
                                    </v-col>
                                    <v-col cols="3" md="4" :class="{ 'px-1': is_tablet, 'py-0': true }">
                                        <AppDateField
                                            ref="invoiceEndDate"
                                            :label="is_tablet ?  'F. final' : 'Fecha final'"
                                            v-model="screen_data.invoice.end_date"
                                            :disabled="!editable"
                                        />
                                    </v-col>
                                </v-row>

                                <v-row v-if="screen_data.invoice.rectificative">
                                    <v-col class="mt-2 mb-0 pb-0">
                                        <p class="py-0 my-0" v-if="screen_data.rectificative_invoice">
                                            Rectifica la factura:
                                            <strong>{{ screen_data.rectificative_invoice.invoice_number }}</strong> del
                                            {{ formattedDate(screen_data.rectificative_invoice.invoice_date) }}.
                                        </p>
                                        <p class="py-0 my-0" v-else>
                                            Rectifica la factura:
                                            <strong>{{ screen_data.invoice.rectificative_info.invoice_number }}</strong>
                                            del
                                            {{ formattedDate(screen_data.invoice.rectificative_info.invoice_date) }}.
                                        </p>
                                        <p class="py-0 my-0">
                                            {{ screen_data.invoice.rectificative_info.reason }}
                                        </p>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                    <v-divider vertical :class="{'pb-4': !is_mobile}"></v-divider>
                    <v-col cols="12" md="12" class="px-0 py-0" :lg="invoiceable_type === 'ticket' ? 6 : 4">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0"> Emisor </p>
                            </v-col>
                        </v-row>
                        <div :class="{ 'sector__input': true, 'pa-8': !is_mobile, 'px-8': is_mobile, 'py-3': is_mobile }">
                            <PartyEditor title="" :party="screen_data.invoice.supplier" :readonly="!editable" :emisor="true"
                                :allow_refresh="editable" @refresh_emisor="refresh_emisor()"
                                :partyOptions="screen_data.customers" :showErrors="screen_data.showErrors"
                                @save_company_as_party="saveComapnyAsParty" :invoiceable_repo="invoiceable_repo"
                                :company_id="companydb_id"
                                :configuration="screen_data.configuration"
                                @success-message="msg => screen_data.success_message(msg)"
                                @error-message="msg => screen_data.error_message(msg)"
                            />
                        </div>
                    </v-col>
                    <v-divider vertical class="pb-1"></v-divider>
                    <v-col cols="12" md="12" lg="4" class="px-0 py-0" v-if="invoiceable_type !== 'ticket'">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0"> Receptor 
                                    <span v-if="screen_data.invoice && screen_data.invoice.customer && customerLabel">
                                        - {{ customerLabel }}
                                    </span>
                                </p>
                            </v-col>
                        </v-row>
                        <div :class="{ 'sector__input': true, 'pa-8': !is_mobile, 'px-8': is_mobile, 'py-3': is_mobile }">
                            <PartyEditor v-if="editorMounted" title="" :party="screen_data.invoice.customer"
                                :readonly="!editable || (screen_data.invoice.rectificative && screen_data.rectificative_invoice != null)"
                                :emisor="false"
                                @update_party="autocompleteCustomer"
                                :partyOptions="screen_data.customers"
                                :showErrors="screen_data.showErrors"
                                @saveThird="saveThird"
                                :invoiceable_repo="invoiceable_repo"
                                :company_id="companydb_id"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-card>
            <!-- {{ screen_data.invoice }} -->
            <v-card class="sector-div" v-if="screen_data.invoice">
                <InvoiceLinesEditor :invoice_lines="screen_data.invoice.lines" :invoice_id="screen_data.invoice.id"
                    :invoice="screen_data.invoice" @delete-line="DeleteLine" @delete-all-lines="DeleteAllLines"
                    @change-line="InvoiceLineChanged" @add-line="AddLine" @import-lines="ImportLines"
                    @change-additional-info="InvoiceAditionalInfoChanged" :allow_import="editable"
                    :loading="screen_data.loading" :readonly="!editable" style="padding-top:0;"
                    :products="screen_data.products" :showErrors="screen_data.showErrors"
                    :tax_type="screen_data.invoice.tax_type?screen_data.invoice.tax_type:'iva'"
                    :invoiceable_type="invoiceable_type"
                    :productConfiguration="screen_data.product_configuration"/>

                <v-row dense class="mt-4 px-4">
                    <v-col cols="12" md="12">
                        <div class="d-flex flex-column gap-2">
                        <v-textarea
                            outlined
                            label="Observaciones"
                            v-model="screen_data.invoice.additional_info"
                            :readonly="!editable"
                            auto-grow
                            rows="3"
                            hide-details
                        />

                        <InvoiceTotalsViewer
                            :invoice="screen_data.invoice"
                            :readonly="true"
                        />
                        </div>
                    </v-col>
                </v-row>

            </v-card>

            <v-card v-if="!is_mobile" class="sector-div">
                <v-row :class="{'ma-0': true, 'flex-sm-nowrap': !is_tablet }">
                    <v-col cols="12"  class="px-0 py-0">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                                <p class="mb-0"> Otros campos </p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" v-if="screen_data.invoice.type === 'invoice' || invoiceable_type === 'ticket'">
                                <div style="padding: 0 20px;margin-top:16px">
                                    <label class="input-label">Método de pago</label>
                                    <v-select
                                        :readonly="!editable"
                                        :items="screen_data.payment_options"
                                        item-value="value"
                                        item-text="text"
                                        outlined
                                        dense
                                        hide-details
                                        v-model="screen_data.invoice.payment_means"
                                        @change="onPaymentMeansChange"
                                        :error="screen_data.showErrors && ['', null, undefined, '00'].includes(screen_data.invoice.payment_means)"
                                        :background-color="screen_data.showErrors && ['', null, undefined, '00'].includes(screen_data.invoice.payment_means) ? '#DC0B0B1A' : ''"
                                    ></v-select>
                                </div>
                            </v-col>
                            <v-col cols="4" v-if="screen_data.invoice.type === 'invoice' || invoiceable_type === 'ticket'">
                                <div style="padding: 0 20px;margin-top:16px">
                                    <label class="input-label">Información de pago</label>
                                    <AppTextFieldV2
                                        v-model="screen_data.invoice.payment_information"
                                        :readonly="!editable"
                                        @input="onPaymentInformationChange"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" >
                                <div style="padding: 0 16px;margin-top:16px">

                                    <v-textarea outlined label="Notas internas" v-model="screen_data.invoice.free_notes" @input="dirtyFreeNotes=true">
                                    </v-textarea>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>

            <!-- card formato movil -->
            <v-card v-if="is_mobile" class="sector-div pb-8">
                <v-row class="ma-0">
                    <v-col cols="12" :class="['px-0 py-0', {'sector-head--mobile' : is_mobile}]">
                        <v-row class="sector-head">
                            <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
                            <p class="mb-0">Otros campos</p>
                            </v-col>
                        </v-row>

                        <v-row dense class="px-4 mt-2" align="start">
                            <v-col
                            cols="12"
                            md="6"
                            v-if="screen_data.invoice.type === 'invoice'"
                            >
                            <v-select
                                :readonly="!editable"
                                :items="screen_data.payment_options"
                                label="Selecciona un método de pago"
                                item-value="value"
                                item-text="text"
                                v-model="screen_data.invoice.payment_means"
                            />
                            </v-col>

                            <v-col cols="12" md="6">
                            <v-textarea
                                outlined
                                label="Notas internas"
                                v-model="screen_data.invoice.free_notes"
                                @input="dirtyFreeNotes = true"
                                auto-grow
                                hide-details
                            />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>

        </template>
        <template v-else-if="screen_data.invoice">
            <v-row class="mx-8">
                <v-col cols="3">
                    <div class="mr-auto d-flex align-sm-center">
                        <v-btn v-if="companydb_id" icon
                            @click="backToList()">
                            <AppIcon :src="require('../../../assets/back-arrow.svg')" :size="29" />
                        </v-btn>
                        <h4 class="primary_blue--text ml-2">Receptor  {{ screen_data.invoice.name }}</h4>
                    </div>
                </v-col>
                <v-col cols="2">
                    <template v-if="screen_data && !screen_data.loading">
                        <span v-if="screen_data.invoice && is_tablet">
                            <p class="ma-0 pa-0">{{ invoice_state }} </p>
                            <v-icon :color="getStateIndicatorClass()" dense small>mdi-circle</v-icon>
                        </span>
                        <div class="rounded-pill grey lighten-3 py-0 d-inline-flex align-sm-center flex-sm-nowrap invoice_state"
                            v-else-if="screen_data.invoice">
                            <div class="text--grey--darken-3 mr-2 pl-4 font-weight-medium">Estado: </div>
                            <div
                                class="d-flex justify-space-between rounded-pill white px-2 mx-2 my-1 py-0 flex-grow-1">
                                <p class="ma-0 pa-0">{{ invoice_state }} </p>
                                <v-icon :color="getStateIndicatorClass()" dense small>mdi-circle</v-icon>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <v-progress-circular indeterminate class="mr-2" color="primary"></v-progress-circular>
                    </template>
                </v-col>
                <template v-if="screen_data && screen_data.invoice">
                    <v-col cols="7" class="text-right">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon class="ml-1" @click="previewRejectDialog(true)"
                                    :disabled="screen_data.invoice.state != 'Confirmada'" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('../../../assets/mark_as_rejected.svg')" :size="29" v-if="screen_data.invoice.state == 'Confirmada'" />
                                    <AppIcon :src="require('../../../assets/mark_as_rejected_disabled.svg')" :size="29" v-else />
                                </v-btn>
                            </template>
                            <span>Rechazar  {{ screen_data.invoice.name }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon class="ml-2" @click="previewPayDialog(true)"
                                    :disabled="screen_data.invoice.state != 'Confirmada'" v-bind="attrs" v-on="on">
                                    <AppIcon :src="require('../../../assets/mark_as_paid.svg')" :size="29" v-if="screen_data.invoice.state == 'Confirmada'" />
                                    <AppIcon :src="require('../../../assets/mark_as_paid_disabled.svg')" :size="29" v-else />
                                </v-btn>
                            </template>
                            <span>Marcar como pagada</span>
                        </v-tooltip>
                    </v-col>
                </template>
                <template v-else>
                    <v-progress-circular indeterminate class="mr-2" color="primary"></v-progress-circular>
                </template>
            </v-row>
            <div class="invoice_center_viewer">
                <StaticInvoiceViewer class="invoice_center_viewer_component" v-if="screen_data.invoice"
                    :invoice="screen_data.invoice" :rectified_inv="screen_data.rectificative_invoice"
                    :configuration="screen_data.configuration" :key="screen_data.invoice.toString()">
                </StaticInvoiceViewer>
            </div>
        </template>
    </v-container>
</template>

<script>
import StaticInvoiceViewer from "@/components/StaticInvoiceViewer.vue";
import InvoiceTotalsViewer from "@/components/InvoiceTotalsViewer.vue"
import InvoiceLinesEditor from "@/components/InvoiceLinesEditor.vue"
import DocTextField from "@/components/DocTextField.vue"
import PartyEditor from "@/components/PartyEditor.vue"
import { VueInvoiceEditorScreenData } from './VueInvoiceEditorScreenData'
import { ApiInvoiceableRepository } from './ApiInvoiceableRepository'
import { ApiProductRepository, ApiProductConfigurationRepository } from "./ApiProductRepository";
import { InvoiceEditorComponent } from '../app/InvoiceEditorComponent'
import { mapState, mapGetters } from 'vuex'
import awsconfig from '../../../aws-exports';
import { S3Repository } from '../../shared/infra/S3Repository'
import AppBtn from '@/components/layout/AppBtn.vue';
import AppIcon from '@/components/layout/AppIcon.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue'
import AppTextFieldV2 from "@/modules/widgets/infra/AppTextFieldV2.vue";
import AppDateField from "@/modules/widgets/infra/AppDateField.vue";
import JobProgress from '@/components/JobProgress.vue';
import { ApiConfigurationRepository } from "./ApiConfigurationRepository";
import SendByEmailForm from '../../notifications/infrastructure/SendByEmailForm.vue'
import {isManualInvoiceNumber, isConfigurationOK, isInvoiceIncomplete, isValidNIF} from '@/modules/facturae/domain/InvoiceableValidation'

export default {
    components: {
        StaticInvoiceViewer,
        InvoiceLinesEditor,
        DocTextField,
        PartyEditor,
        AppBtn,
        AppIcon,
        InvoiceTotalsViewer,
        AppConfirmModal,
        AppTextFieldV2,
        AppDateField,
        JobProgress,
        SendByEmailForm
    },
    props: {
        invoiceable_id: {
            type: [Number, String],
            required: false,
            default: null
        },
        companydb_id: {
            type: [Number, String],
            required: false,
            default: null
        },
        next_number: {
            type: [String],
            required: false,
            default: null
        },
        next_rectificative_number: {
            type: [String],
            required: false,
            default: null
        },
        default_sequence_id: {
            type: [Number],
            required: false,
            default: null
        },
        invoiceable_type: {
            type: [String],
            required: false,
            default: 'invoice'
        },
        invoiceable_id_list: {
            type: [Array],
            required: false,
            default: null
        }
    },
    data() {
        const screen_data = new VueInvoiceEditorScreenData();

        screen_data.showErrorsDialog = false;
        screen_data.errorDialogMessage = '';
        screen_data.showErrorsDialogVerifactu = false;
        screen_data.setErrorDialog = (show, message = '') => {
            screen_data.showErrorsDialog = show;
            screen_data.errorDialogMessage = message;
        };

        screen_data.setErrorDialogVerifactu = (show, message = 'Error en la factura, envío a VERI*FACTU cancelado.') => {
            screen_data.showErrorsDialogVerifactu = show;
            screen_data.errorDialogMessage = message;
        };


        return {
            temp_payment_state: '',
            party_window: 'Receptor', // 'Emisor' o 'Receptor
            screen_data: screen_data,
            invoice_editor_component: null,
            error_upload_file: false,
            invoiceDateVisible: false,
            dueDateVisible: false,
            startDateVisible: false,
            endDateVisible: false,
            viewer_dialog: false,
            reject_dialog: false,
            dirtyPaymentState: false,
            dirtyFreeNotes: false,
            speedDial: false,
            invoiceable_repo: null,
            editorMounted: false,
        }
    },
    watch: {
        companydb_id: function (newVal, oldVal) {
            let name = this.invoiceable_type == 'budget' ? 'budget-list' : this.invoiceable_type == 'delivery_note' ? 'delivery-note-list' : this.invoiceable_type == 'ticket' ? 'ticket-list' : this.invoiceable_type == 'proforma' ? 'proforma-list' : 'invoice-list'
            this.screen_data.companydb_id = newVal
            this.$router.push({ 'name': name, 'params': { 'companydb_id': newVal } })
        }
    },
    async mounted() {
        this.creds = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
        });
        this.creds.params.Logins = this.creds.params.Logins || {};
        this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] = this.session_information.signInUserSession.idToken.jwtToken;
        this.creds.expired = true;
        AWS.config.update({
            region: awsconfig['aws_user_files_s3_bucket_region'],
            credentials: this.creds,
        });
        let s3_repo = new S3Repository(AWS, 'excel_lines')
        let product_repo = new ApiProductRepository()
        let config_repo = new ApiConfigurationRepository()
        this.invoiceable_repo = new ApiInvoiceableRepository()
        let product_config_repo = new ApiProductConfigurationRepository()
        this.screen_data.companydb_id = this.companydb_id
        this.invoice_editor_component = new InvoiceEditorComponent(this.invoiceable_repo,
                                                                   s3_repo, this.screen_data,
                                                                   product_repo, config_repo,
                                                                   this.invoiceable_type,
                                                                   this.currentCompany,
                                                                   product_config_repo)
        let correctMount = await this.invoice_editor_component.mountEditor(this.invoiceable_id,
                                                                           this.companydb_id,
                                                                           this.next_number,
                                                                           this.next_rectificative_number,
                                                                           this.default_sequence_id,
                                                                           this.invoiceable_id_list)
        if (!correctMount) {
            this.backToList();
        }
        this.editorMounted = true
        this.updateTempPaymentState()
    },
    activated() {
        if (this.editorMounted && this.currentCompany) {
            this.refresh_emisor();
        }
    },
    methods: {
        getTodayDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        goLeft() {
            if (
            this.screen_data.invoiceableIdList &&
            this.screen_data.invoiceableIdList.length > 0 &&
            this.screen_data.invoiceableIdList.indexOf(this.invoiceable_id) > 0
            ) {
                let index = this.screen_data.invoiceableIdList.indexOf(this.invoiceable_id);
                let name_url
                if (this.invoiceable_type!='delivery_note'){
                    name_url = this.invoiceable_type + '-editor'
                }else{
                    name_url = 'delivery-note-editor'
                }
                this.$router.replace({
                    name: name_url,
                    params: {
                        companydb_id: this.companydb_id,
                        [this.invoiceable_type + '_id']: this.screen_data.invoiceableIdList[index - 1],
                        invoiceable_id_list: this.screen_data.invoiceableIdList
                    }
                });
            }
        },
        goRight() {
            if (
            this.screen_data.invoiceableIdList &&
            this.screen_data.invoiceableIdList.length > 0 &&
            this.screen_data.invoiceableIdList.indexOf(this.invoiceable_id) < this.screen_data.invoiceableIdList.length - 1
            ) {
                let index = this.screen_data.invoiceableIdList.indexOf(this.invoiceable_id);
                let name_url
                if (this.invoiceable_type!='delivery_note'){
                    name_url = this.invoiceable_type + '-editor'
                }else{
                    name_url = 'delivery-note-editor'
                }
                this.$router.replace({
                    name: name_url,
                    params: {
                        companydb_id: this.companydb_id,
                        [this.invoiceable_type + '_id']: this.screen_data.invoiceableIdList[index + 1],
                        invoiceable_id_list: this.screen_data.invoiceableIdList
                    }
                });     
            }
        },
        onPaymentMeansChange(){
            this.screen_data.invoice.flag_payment_means_modified = true
        },
        onPaymentInformationChange(){
            this.screen_data.invoice.flag_payment_information_modified = true
        },
        sequenceChanged() {
            this.invoice_editor_component.sequenceChanged()
        },
        getStateIndicatorClass() {
            if (this.invoice_state === 'Borrador') {
                return '#FF8533';
            } else if (['Confirmada', 'Enviada', 'Enviada por mail', 'Firmada', 'Emitida', 'Enviado por email', 'Emitido'].includes(this.invoice_state)) {
                return '#FFF333'
            } else if (['Pagado', 'Aceptado', 'Facturado'].includes(this.invoice_state)) {
                return '#67c767';
            } else if (['Rechazada', 'Rechazado'].includes(this.invoice_state)) {
                return '#d53d3d';
            } else {
                return '#808080'; // Default class name
            }
        },
        getPaymentStateIndicatorClass() {
            if (this.paymentStateToShow === 'Pendiente') {
                return '#FF8533';
            }
            else if( this.paymentStateToShow === 'Remesada'){
                return '#FFF333'
            } else if (this.paymentStateToShow === 'Pagada') {
                return '#67c767';
            } else if (this.paymentStateToShow === 'Vencida' || this.paymentStateToShow === 'Rectificada') {
                return '#d53d3d';
            } else {
                return '#808080'; // Default class name
            }
        },
        InvoiceAditionalInfoChanged() {
            console.log("InvoiceAditionalInfoChanged")
            this.invoice_editor_component.update_invoice()
        },
        InvoiceLineChanged(i) {
            console.log("InvoiceLineChanged")
            this.invoice_editor_component.update_invoice_line(i)
            this.invoice_editor_component.update_invoice()
        },
        AddLine() {
            console.log("LinesAmountChanged")
            this.invoice_editor_component.add_line()
        },
        DeleteLine(i) {
            console.log("DeleteLine")
            this.invoice_editor_component.delete_line(i)
            this.invoice_editor_component.update_invoice()
        },
        DeleteAllLines() {
            console.log("DeleteAllLines")
            this.invoice_editor_component.delete_all_lines()
        },
        ImportLines() {
            console.log("ImportLines")
            this.invoice_editor_component.import_excel_lines()
        },
        emisorPopUp() {
            this.invoice_editor_component.show_supplier_pop_up()
        },
        receptorPopUp() {
            this.invoice_editor_component.show_customer_pop_up()
        },
        previewInvoice() {
            this.viewer_dialog = true;
        },
        unsign() {
            this.invoice_editor_component.unsign_invoice()
        },
        async saveInvoice() {
            this.screen_data.invoice.payment_state = this.temp_payment_state
            this.temp_payment_state = ''
            await this.invoice_editor_component.save_invoice()
            if (this.invoiceable_type == 'budget') {
                this.$router.replace({ name: 'budget-editor', params: { 'companydb_id': this.companydb_id, 'budget_id': this.screen_data.invoice.id } });
            } else if (this.invoiceable_type == 'delivery_note') {
                this.$router.replace({ name: 'delivery-note-editor', params: { 'companydb_id': this.companydb_id, 'delivery_note_id': this.screen_data.invoice.id } });
            } else if (this.invoiceable_type == 'proforma') {
                this.$router.replace({ name: 'proforma-editor', params: { 'companydb_id': this.companydb_id, 'proforma_id': this.screen_data.invoice.id } });
            } else if (this.invoiceable_type == 'ticket') {
                this.$router.replace({ name: 'ticket-editor', params: { 'companydb_id': this.companydb_id, 'ticket_id': this.screen_data.invoice.id } })
            } else {
                this.$router.replace({ name: 'invoice-editor', params: { 'companydb_id': this.companydb_id, 'invoice_id': this.screen_data.invoice.id } });
            }
            this.updateTempPaymentState()
            this.dirtyPaymentState = false
            this.dirtyFreeNotes = false
        },
        updateTempPaymentState() {
            this.temp_payment_state = this.screen_data.invoice.payment_state
        },
        async downloadInvoice() {
            await this.invoice_editor_component.download_e_invoice()
        },
        cancelDownload () {
            this.screen_data.download_type = ''
            this.screen_data.downloadPopup = false
        },
        showErrorAsyncjob() {
            if (this.screen_data.action == 'download') {
                this.screen_data.error_message('Error al descargar la factura')
            } else if (['send_email', 'send_accounting', 'send_invoice'].includes(this.screen_data.action)) {
                this.screen_data.error_message('Error al enviar la factura')
            } else {
                this.screen_data.error_message('Error en el proceso')
                this.screen_data.setLoading(false)
            }
        },
        previewSignDialog(value) {
            this.screen_data.confirmSignDialog = value;
        },
        async signInvoice() {
            console.log("sign_invoice")
            if (!isManualInvoiceNumber(this.got_feature('feature_manual_invoice_number'), this.screen_data.invoice) && !isConfigurationOK(this.screen_data.invoice, this.screen_data.selectedSequence, this.screen_data.configuration && this.screen_data.configuration.sequences, this.invoiceable_type)) {
                this.screen_data.error_message('La configuración de la serie de facturación no es correcta')
                return
            }
            const validationResult = isInvoiceIncomplete(
                this.screen_data.invoice,
                this.screen_data.selectedSequence,
                this.invoiceable_type,
                this.got_feature('feature_facturae_allow_lines_at_zero'),
                this.got_feature('feature_invoice_date_editable')
            )
            if (validationResult.isIncomplete) {
                this.screen_data.showErrors = true
                const errorMessage = validationResult.errors.length > 0
                    ? validationResult.errors.join('\n')
                    : ''
                this.screen_data.setErrorDialog(true, errorMessage)
                return
            }

            // Validate NIF for physical person (only if the country is Spain)
            if (this.screen_data.invoice.customer && this.screen_data.invoice.customer.type === 'fisica') {
                if (!isValidNIF(this.screen_data.invoice.customer.cif, this.screen_data.invoice.customer.country || '')) {
                    this.screen_data.error_message('El NIF del cliente no es válido')
                    return
                }
            }


            const invoiceDate = this.screen_data.invoice.invoice_date;
            const dueDate = this.screen_data.invoice.invoice_due_date;
            if (dueDate && invoiceDate && new Date(dueDate) < new Date(invoiceDate)){
                this.screen_data.error_message('No puede ser la fecha de vencimiento anterior a la fecha de ' + this.screen_data.invoice.name)
                return
            }

            await this.invoice_editor_component.checkDraftInvoiceables()
            
            this.previewSignDialog(true)
        },
        async confirmSignInvoice() {
            //console.log("confirmSignInvoice")
            this.previewSignDialog(false)

            const today = this.getTodayDate();

            if (this.got_feature('feature_invoice_operation_date')) {
                this.screen_data.invoice.invoice_date = today;
                if (!this.screen_data.invoice.operation_date) {
                    this.screen_data.invoice.operation_date = today;
                }
            }

            if (this.screen_data.invoice.invoice_due_date && new Date(this.screen_data.invoice.invoice_due_date) < new Date(today) && !this.got_feature('feature_invoice_date_editable')) {
                this.screen_data.invoice.invoice_due_date = today;
            }

            if (['budget', 'delivery_note', 'proforma'].includes(this.invoiceable_type)) {
                await this.invoice_editor_component.issue_invoice()
            } else {
                await this.invoice_editor_component.sign_invoice()
            }
            this.updateTempPaymentState()
        },
        cancelSend() {
            this.screen_data.send_dialog = false
            this.screen_data.emailForm = {
                to: '',
                subject: '',
                body: ''
            }
            this.screen_data.senderOption = ''
        },
        openSendDialog() {
            if (this.screen_data.configuration && this.screen_data.configuration.email_template) {
                this.screen_data.emailForm['subject'] = this.screen_data.configuration.email_template.subject
                this.screen_data.emailForm['body'] = this.screen_data.configuration.email_template.message
            }
            if (this.screen_data.invoice.customer) {
                this.screen_data.emailForm['to'] = this.screen_data.invoice.customer.email
            }
            this.screen_data.send_dialog = true
        },
        async sendInvoice() {
            console.log("send_invoice")
            await this.invoice_editor_component.send_e_invoice()
        },
        formattedDate(date) {
            return date ? new Date(date).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }) : '';
        },
        handleDateChange(dateField, menuVisibility) {
            this[menuVisibility] = false;
            return (value) => {
                this.screen_data.invoice[dateField] = value;
            };
        },
        autocompleteCustomer(party) {
            this.screen_data.setCustomer(party)
            this.screen_data.setPaymentMeans(party.payment_means)
            this.screen_data.setPaymentInformation(party.payment_information)
        },
        refresh_emisor() {
            this.invoice_editor_component.refresh_emisor(this.currentCompany)
        },
        reloadPage() {
            window.location.reload()
        },
        previewRejectDialog(value) {
            this.screen_data.setRejectDialog(value);
        },
        async rejectInvoice() {
            await this.invoice_editor_component.reject_invoice();
        },
        previewPayDialog(value) {
            this.screen_data.setPaidDialog(value);
        },
        async markAsAccepted() {
            await this.invoice_editor_component.pay_accept_invoice()
        },
        openToPrint() {
            let name = this.got_feature('feature_custom_invoice_templates')?'report-invoice-dynamic':'report-invoice'
            sessionStorage.setItem('reportInvoiceID', this.screen_data.invoice.id);
            let routeData = this.$router.resolve({
                name: name,
                params: {
                    'invoiceable_id': this.screen_data.invoice.id,
                }
            });
            window.open(routeData.href, '_blank');
        },
        goToOtherDocument() {
            console.log('goToOtherDocument', this.screen_data.invoice.source_odoc_id)
            let routeData = this.$router.resolve({ name: 'other-doc-detail', params: { 'other_document_id': this.screen_data.invoice.source_odoc_id } });
            window.open(routeData.href, '_blank');
        },
        goToDocument() {
            this.$router.push({ name: 'document-detail', params: { 'document': this.screen_data.invoice.accounting_document_id } });
        },
        async saveThird(party) {
            this.screen_data.setPaymentMeans(party.payment_means)
            this.screen_data.setPaymentInformation(party.payment_information)
            const success = await this.invoice_editor_component.save_third_party(party)
            if (success && this.screen_data.invoice.state == 'draft') {
                await this.saveInvoice()
            }
            return success
        },
        async saveComapnyAsParty(party) {
            const success = await this.invoice_editor_component.save_company_as_party(party)
            if (success && this.screen_data.invoice.state == 'draft') {
                await this.saveInvoice()
            }
            return success
        },
        backToList() {
            let routerName = this.invoiceable_type == 'budget' ? 'budget-list' : this.invoiceable_type == 'delivery_note' ? 'delivery-note-list' : this.invoiceable_type == 'ticket' ? 'ticket-list' : this.invoiceable_type == 'proforma' ? 'proforma-list' : 'invoice-list'
            this.$router.push({ name: routerName, params: { 'companydb_id': this.companydb_id } });
            return
        },
        newInvoiceable() {
            let routerName = this.invoiceable_type == 'budget' ? 'budget-editor' : this.invoiceable_type == 'delivery_note' ? 'delivery-note-editor' : this.invoiceable_type == 'ticket' ? 'ticket-editor' : this.invoiceable_type == 'proforma' ? 'proforma-editor' : 'invoice-editor'
            this.$router.replace({ name: routerName, params: { 'companydb_id': this.companydb_id } });
        },

        async jobDone() {
            try {
                const res = await this.invoice_editor_component.jobDone();
                
            } catch (error) {
                console.error('Error while job done function:', error);
            }
        },
    },
    computed: {
        ...mapState([
            'session_information',
            'currentCompany'
        ]),
        ...mapGetters({
            got_feature: 'got_feature',
            is_mobile: 'is_mobile',
            screen_size: 'screen_size',
            userData: 'me/userData',
        }),
        customerLabel() {
            const inv = this.screen_data && this.screen_data.invoice ? this.screen_data.invoice : null;
            const c = inv && inv.customer ? inv.customer : null;
            if (!c) return '';
            if (c.type === 'juridica' && c.business_name) {
                return c.business_name;
            }
            if (c.type === 'fisica') {
                const fs = c.first_surname || '';
                const ss = c.second_surname || '';
                const nm = c.name || '';
                const parts = [];
                const surnames = (fs + ' ' + ss).trim();
                if (surnames) parts.push(surnames);
                if (nm) parts.push(nm);
                return parts.length ? parts.join(', ') : '';
            }
            return '';
        },
        is_manual_invoice_number() {
            return this.got_feature('feature_manual_invoice_number') || (this.screen_data.invoice && this.screen_data.invoice.name == 'proforma')
        },
        cantSave(){
            return !this.editable && !this.dirtyPaymentState && !this.dirtyFreeNotes
        },
        invoice_state() {
            if (this.invoice_editor_component) {
                if (this.invoice_editor_component.state_translator[this.screen_data.invoice.state]) {
                    return this.invoice_editor_component.state_translator[this.screen_data.invoice.state]
                } else {
                    return this.screen_data.invoice.state
                }
            } else {
                return ""
            }
        },
        canGoLeft() {
            return this.screen_data.invoiceableIdList && this.screen_data.invoiceableIdList.length > 0 && this.screen_data.invoiceableIdList.indexOf(this.invoiceable_id) > 0
        },
        canGoRight() {
            return this.screen_data.invoiceableIdList && this.screen_data.invoiceableIdList.length > 0 && this.screen_data.invoiceableIdList.indexOf(this.invoiceable_id) < this.screen_data.invoiceableIdList.length - 1
        },
        canSend() {
            const isEmpty = (value) => ['', null, undefined].includes(value);
            return this.screen_data.senderOption === '' ||
                (this.screen_data.senderOption === 'CONT' && (
                    !isEmpty(this.screen_data.invoice.accounting_document_id) ||
                    (this.screen_data.invoice.total_taxes_withheld && this.screen_data.invoice.total_taxes_withheld.length > 1) ||
                    (!isEmpty(this.screen_data.invoice.retention_amount) && this.screen_data.invoice.total_taxes_withheld.length > 0))
                ) || (this.screen_data.senderOption === 'EMAIL' && (
                    isEmpty(this.screen_data.emailForm.to) ||
                    isEmpty(this.screen_data.emailForm.subject) ||
                    isEmpty(this.screen_data.emailForm.body))
                );
        },
        computed_payment_states() {
            let states = [{ 'value': 'paid', 'name': 'Pagada' },{'value': 'remitted', 'name': 'Remesada' }, { 'value': 'pending', 'name': 'Pendiente' }]
            if (this.screen_data.invoice && this.screen_data.invoice.payment_state == 'overdue') {
                states.push({ 'value': 'overdue', 'name': 'Vencida' })
            }
            else if (this.screen_data.invoice && this.screen_data.invoice.payment_state == 'rectified') {
                states.push({ 'value': 'rectified', 'name': 'Rectificada' })
            }
            return states
        },
        paymentStateToShow() {
            if (this.invoice_editor_component && this.screen_data.invoice && this.screen_data.invoice.state != 'draft') {
                if (this.invoice_editor_component.payment_state_translator[this.screen_data.invoice.payment_state]) {
                    return this.invoice_editor_component.payment_state_translator[this.screen_data.invoice.payment_state]
                } else {
                    this.screen_data.invoice.payment_state
                }
            } else {
                return ""
            }
        },
        editable() {
            if (!this.screen_data || !this.screen_data.invoice) {
                return false
            }
            return this.screen_data.invoice.state == 'draft'
        },
        sendable() {
            if (!this.screen_data || !this.screen_data.invoice) {
                return false
            }
            return this.screen_data.invoice.state == 'signed' || this.screen_data.invoice.state == 'sent_via_mail'
        },
        mail_sendable() {
            if (!this.screen_data || !this.screen_data.invoice) {
                return false
            }
            return this.screen_data.invoice.state != 'draft'
        },
        allowSignature() {
            return (this.screen_data.invoice.invoice_number || this.screen_data.invoice.sequence_id) && this.screen_data.invoice.invoice_date && this.screen_data.invoice.customer && this.screen_data.invoice.customer.cif && this.screen_data.invoice.supplier && this.screen_data.invoice.supplier.cif && this.screen_data.invoice.lines.length > 0
        },
        is_tablet() {
            let tablet = false;
            if (this.is_mobile || this.screen_size == 'md') {
                tablet = true;
            }
            return tablet;
        },
        stateSlot() {
            return this.screen_data.asyncJobState === 'done' || this.screen_data.asyncJobState === 'error' ? 'done' : '';
        },
        isDueDateInvalid() {
            const invoiceDate = this.screen_data.invoice.invoice_date;
            const dueDate = this.screen_data.invoice.invoice_due_date;
            if (invoiceDate && dueDate) {
                return new Date(dueDate) < new Date(invoiceDate);
            }
            return false;
        },
        isDueDateBeforeToday() {
            if (!this.got_feature('feature_invoice_operation_date')) {
                return false;
            }
            const dueDate = this.screen_data.invoice.invoice_due_date;
            if (!dueDate) return false;
            const today = this.getTodayDate();
            return new Date(dueDate) < new Date(today);
        },
    },

}
</script>

<style>
.title-color {
    color: var(--v-primary-base);
}

.overflow-hidden {
    overflow-x: hidden;
}

.sector-head {
    padding: 0px;
    background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
    max-height: 50px;
    margin: 0px
}

.right-border {
    border-right: 1px solid #e0e0e0;
}

.sector-div {
    background-color: #f5f5f5;
    padding: 0px;
    min-width: 100% !important;
}

.custom-font .v-input__control .v-input__slot {
    background: rgba(0, 0, 0, 0) !important;
    border-bottom: 0px solid transparent !important;
    border-color: rgba(0, 0, 0, 0) !important;
}

.sector__input .row .col {
    padding-top: 2px;
    padding-bottom: 2px;
    font-size: 12px !important;
}

.sector__input {
    padding-top: 10px;
}

.sector__input label {
    font-weight: 500;
}
</style>

<style lang="scss" scoped>
.custom-gray-text>>>.v-input__control .v-input__slot .v-text-field__slot {
    color: gray;
}

.low-size-font >>> input {
    background-color: blue !important;
    color: red !important;
    font-size: 9px !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
}

.state-container {
    display: flex;
    align-items: center;
}

.state-text {
    border: 2px solid gray;
    border-radius: 20px;
    padding: 8px 16px;
    margin-right: 10px;
}

.state-indicator {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.state-indicator--draft {
    background-color: #FF8533;
}

.state-indicator--approved {
    background-color: #67c767;
}

.state-indicator--rejected {
    background-color: #d53d3d;
}

.state-indicator--default {
    background-color: gray;
}

.container-full-bg-white {
    height: 100%;
    background-color: white;
    border-top-left-radius: 15px;
    position: absolute;
    overflow-y: auto;
    padding: 0px;
}

.invoice_container {
    overflow-x: hidden;
}

.invoice_state {
    width: 100% !important;
}

.invoice_right_viewer .v-dialog.v-dialog--active {
    margin: 0;
}

.invoice_right_viewer {
    position: absolute !important;
    right: 0 !important;
    height: 100vh !important;
    width: 50% !important;
    overflow-y: auto;
    background-color: red !important;
}

.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}

.error__dialog .v-card__title {
    background-color: #DC0B0BE5 !important;
    color: white !important;
    font-family: 'Roboto', sans-serif !important;
    font-weight: 600 !important;
    font-size: 20px !important;
    line-height: 24px !important;
}

.input-label {
    font-size: 13px !important;
    font-weight: 500 !important;
}

.btn_pointer {
    cursor: pointer;
}
</style>

<style>
.custom-select>.v-text-field.v-text-field--solo .v-input__control,
.custom-select>.v-text-field.v-text-field--solo .v-select__slot,
.custom-select>.v-text-field.v-text-field--solo .v-input__slot {
    min-height: 5px !important;
    max-height: 25px !important;
    padding: 0px !important;
}

.invoice_right_viewer .v-dialog.v-dialog--active {
    margin: 0;
}

.invoice_right_viewer {
    position: absolute;
    right: 0;
    left: auto;
    height: 100vh;
    width: 50%;
    overflow-y: auto;
    margin: 0;
    max-height: 100% !important;
}

.invoice_center_viewer {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}

.invoice_center_viewer_component {
    height: auto !important;
    min-height: auto !important;
    border: 1px solid rgba(86, 86, 86, 0.502);
    max-width: 1200px;
}

.primary__blue {
    color: var(--v-primary_blue-base);
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}

.transparent-menu.v-menu__content {
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
}

.transparent-list {
    background-color: transparent !important;
    box-shadow: none !important;
    padding-top: 6px !important;
}

.transparent-list > .v-list-item {
    min-height:32px !important;
    padding-left: 0px !important;
}

.menu-anchor {
    position: relative;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 26px 20px;
}
</style>

<style>
.v-application .px-8 {
    padding-right: 12px !important;
    padding-left: 12px !important;
}
</style>

<style scoped>
#menu-anchor{
    margin-right: 8px;
}

.v-sheet .sector-head--mobile{
    display: flex !important;
    flex-direction: column !important;
}
</style>